module.exports = __webpack_public_path__ + "static/img/35.9f0397a0.png";